import React, { Component } from "react";
import { Result, Button, Typography } from "antd";

import { Link } from "react-router-dom";

class NoAuthorizedSuccess extends Component {
  onCloseWindows = e => {
    e.preventDefault();
    this.props.window.close();
  };
  render() {
    const { Paragraph, Text } = Typography;
    sessionStorage.removeItem('containerInfos_unchoice');
    return (
        <div>
          <Result
              status="success"
              extra={[
                <div>
                  <Paragraph>
                    <Text strong style={{ fontSize: 18 }}>
                      Thank you for your feedback.
                      <br />
                      We will contact you to follow up as soon as possible.
                      <br />
                    </Text>
                  </Paragraph>
                  <Paragraph>
                    <Text strong style={{ fontSize: 18 }}>
                      Thank you,
                      <br />
                      OOCL Customer Services.
                      <br />
                    </Text>
                  </Paragraph>
                </div>,
                <Link to="/">
                  <Button icon="close" type="primary" key="console">
                    Close
                  </Button>
                </Link>
              ]}
          />
        </div>
    );
  }
}

export default NoAuthorizedSuccess;
